<template>
    <div>
        <div class="unitList" v-if="unitList.length">
            <div class="unit-block lock" v-for="(item,index) in unitList" :key="'b'+index">
                <div class="unit-btn" :class="[item.studyState]">
                    <div>{{item.name}}</div>
                </div>
                <img v-if="item.studyState==0" class="lock-icon"
                     src="../../../../assets/img/grammarTest/lock.png" alt="">
            </div>
        </div>
        <div class="unitList" v-else>
            <div class="not-data">
                <div>
                    <img src="../../../../assets/img/word/not_find_data.png" alt="">
                    <span>暂时木有内容呀 ~ ~</span>
                </div>
            </div>
        </div>
        <!--             单元回忆组件-->
        <overall-memory :showPop="showPop" @closePop="closePop"></overall-memory>
    </div>
</template>
<script>
    import overallMemory from '@/components/overallMemory'
    import {unitList} from "@/api/words";
    import Lockr from 'lockr'

    export default {
        components: {overallMemory},
        data() {
            return {
                unitList: {},//单元列表
                showPop: false,
            };
        },
        methods: {
            //获取单元列表
            getUnitList() {
                let unitId = this.$route.query.id
                let data = {
                    token: Lockr.get('token'),
                    curriculum_id: unitId
                }
                unitList(data).then((res) => {
                    this.unitList = res.data//单元列表
                    this.unitList.map(item => {
                        if (item.is_pass == 0) this.$set(item, `studyState`, '')
                        if (item.is_pass == 1) this.$set(item, `studyState`, 'unfinished')
                        if (item.is_pass == 2) this.$set(item, `studyState`, 'finished')
                    })
                })
            },
            startTest() {
                this.showPop = true
            },
            // 关闭
            closePop() {
                this.showPop = false
            },
        },
        created() {
            this.getUnitList()

        },
    }
</script>

<style scoped lang='less'>
    .unitList {
        border: 1px solid #DEDEDE;
        margin: 0 10px;
        display: flex;
        flex-wrap: wrap;
        min-height: 200px;

        .unit-block {
            width: 18%;
            height: 70px;
            margin: 10px 1%;
            background: linear-gradient(270deg, rgba(255, 197, 103, 1) 0%, rgba(255, 157, 0, 1) 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            /*flex-direction: column;*/
            font-size: 19px;
            color: #fff;
            cursor: pointer;
            position: relative;
            transition: all .3s;
            overflow: hidden;
            position: relative;

            .unit-btn {
                flex: 1;
                transition: all .5s;

                > div {
                    height: 70px;
                    line-height: 70px;
                    text-align: center;
                }
            }
            .finished {
                background: #69b33c;
            }

            .unfinished {
                background: #ffa616;
            }
            .allow-active:hover {
                background: #FF640C;
            }

            .unit-hidden {
                margin-right: -35px;
                transition: all .5s;
                width: 35px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                > div {
                    width: 35px;
                    height: 35px;
                    transition: all .5s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                > div:hover {
                    background: #FF640C;
                }

                .video-icon {
                    width: 20px;
                    height: 20px;

                }

                .bell-icon {
                    width: 20px;
                    height: 20px;
                }
            }


        }

        .allow-active:hover {
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

            .unit-hidden {
                margin-right: 0;
            }
        }

        .lock {
            background: #818181;
        }

        .lock:hover {
            background: #818181;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }

        .lock-icon {
            position: absolute;
            bottom: 5px;
            right: 5px;
            height: 25px;
            width: 25px;
        }
    }

    .not-data {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #666;

        > div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                margin-bottom: 10px;
            }
        }
    }
</style>